import React from 'react'
import { useNinetailedHashScroll } from '@toasttab/shared/src/utils/Ninetailed/useNinetailedHashScroll'

const NinetailedHashScroll = () => {
  useNinetailedHashScroll()
  return null
}

export default NinetailedHashScroll
